import * as Yup from 'yup';
import { translate } from 'helpers/intl';
import get from 'lodash/get';
import messages from 'containers/MyAccountPage/messages';
import { FormProps } from 'containers/MyAccountPage/Form';
import labels from 'utils/labels';

export default (props: FormProps) =>
  Yup.object().shape({
    birthday: Yup.string().required(
      translate(get(messages, 'requiredField'), props),
    ),
    phoneNumber: Yup.string().required(
      translate(get(messages, 'requiredField'), props),
    ),
    oldEmail: Yup.string().email().nullable().notRequired(),
    email: Yup.string()
      .email(translate({ id: labels.invalidEmailFormat }, props))
      .nullable()
      .notRequired()
      .when('oldEmail', {
        is: (value) => !!value,
        then: Yup.string()
          .email(translate({ id: labels.invalidEmailFormat }, props))
          .required(translate(get(messages, 'requiredField'), props)),
        otherwise: Yup.string()
          .email(translate({ id: labels.invalidEmailFormat }, props))
          .nullable()
          .notRequired(),
      }),
  });
